
import React from 'react';
import Loading from '../loading/loading';
import { useResizeObserver } from '../../hooks/useResizeObserver';

/**
 * Componente contenedor para widgets
 * @param {Object} props
 * @param {Boolean} props.loading - Estado de carga
 * @param {String} props.className - Clase CSS adicional
 * @param {React.ReactNode} props.children - Contenido del widget
 */
const WidgetContainer = ({ loading, className = '', heightLoading, children, id }) => {
  const containerRef = useResizeObserver();

  return (
    <div className={`${className}`} ref={containerRef} id={id}>
      {loading ? <Loading type={heightLoading} /> : children}
    </div>
  );
};

export default WidgetContainer;